import Immutable from 'immutable';
import {
  CLEAR_ERROR_POSTING_PRICING_PROFILE_REPORT,
  DOWNLOAD_PRICING_PROFILE_REPORT,
  FLAG_POSTING_PRICING_PROFILE_REPORT,
  POST_PRICING_PROFILE_REPORT,
  SHOW_ERROR_POSTING_PRICING_PROFILE_REPORT,
  GET_PRICING_PROFILE_REPORTS,
  GET_PRICING_PROFILE_REPORT,
  CLEAR_PRICING_PROFILE_REPORTS,
  CLEAR_PRICING_PROFILE_REPORT,
  FLAG_GETTING_PRICING_PROFILE_REPORTS,
  FLAG_GETTING_PRICING_PROFILE_REPORT,
  CLEAR_ERROR_GETTING_PRICING_PROFILE_REPORT,
  SHOW_ERROR_GETTING_PRICING_PROFILE_REPORT,
  SHOW_ERROR_GETTING_PRICING_PROFILE_REPORTS,
  CLEAR_ERROR_GETTING_PRICING_PROFILE_REPORTS,
} from '../../../actions/types';
import downloadCsv from '../../../utils/download-csv';

const INITIAL_STATE = Immutable.Map({
  form: Immutable.Map({
    error: null,
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    error: null,
    loading: false,
  }),
  all: Immutable.Map({
    content: Immutable.Map(),
    error: null,
    loading: false,
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // downloading
    case DOWNLOAD_PRICING_PROFILE_REPORT:
      downloadCsv(action.payload, 'pricing-profile-report.csv');
      return state;

    // posting
    case FLAG_POSTING_PRICING_PROFILE_REPORT:
      return state.setIn(['form', 'loading'], action.payload);
    case POST_PRICING_PROFILE_REPORT:
      return state.setIn(['current', 'content'], Immutable.Map(action.payload));
    case SHOW_ERROR_POSTING_PRICING_PROFILE_REPORT:
      return state.setIn(['form', 'error'], action.payload);
    case CLEAR_ERROR_POSTING_PRICING_PROFILE_REPORT:
      return state.deleteIn(['form', 'error']);

    // getting all
    case GET_PRICING_PROFILE_REPORTS:
      return state.setIn(['all', 'content'], Immutable.Map(action.payload));
    case FLAG_GETTING_PRICING_PROFILE_REPORTS:
      return state.setIn(['all', 'loading'], action.payload);
    case CLEAR_PRICING_PROFILE_REPORTS:
      return state.deleteIn(['all', 'content']);
    case SHOW_ERROR_GETTING_PRICING_PROFILE_REPORTS:
      return state.setIn(['all', 'error'], action.payload);
    case CLEAR_ERROR_GETTING_PRICING_PROFILE_REPORTS:
      return state.deleteIn(['all', 'error']);

    // getting one
    case GET_PRICING_PROFILE_REPORT:
      return state.setIn(['current', 'content'], Immutable.Map(action.payload));
    case FLAG_GETTING_PRICING_PROFILE_REPORT:
      return state.setIn(['current', 'loading'], action.payload);
    case CLEAR_PRICING_PROFILE_REPORT:
      return state.deleteIn(['current', 'content']);
    case CLEAR_ERROR_GETTING_PRICING_PROFILE_REPORT:
      return state.deleteIn(['current', 'error']);
    case SHOW_ERROR_GETTING_PRICING_PROFILE_REPORT:
      return state.setIn(['current', 'error'], action.payload);

    default:
      return state;
  }
};
